import React from 'react'
import { useSelector } from 'react-redux'
import { filterItemsByOrderStatus } from '../../utils/filter'
import { NoResults } from '../reusables/noResults'
import { LoadingScreen } from '../../loading/loading'
import { COMPLETED_FILTER } from '../../const'
import { Grid } from '@material-ui/core'
import { OrderCards } from '../orderCards/orderCards'
import { todaysDeliveriesTitleMap } from '../todaysDeliveries/todaysDeliveriesContent'

export const Completed = () => {
  const { todaysDeliveries, isLoading } = useSelector(state => state.today)
  const { language } = useSelector(state => state.auth)
  const completed = filterItemsByOrderStatus(todaysDeliveries.trips, COMPLETED_FILTER)

  return isLoading ? (
    <LoadingScreen />
  ) : (
    <Grid container alignItems="center" justify="center">
      {completed.length === 0 ? (
        <NoResults />
      ) : (
        <OrderCards data={completed} title={todaysDeliveriesTitleMap.completed[language]} orderBy={'updatedAt'} />
      )}
    </Grid>
  )
}
